import React from "react";
import './stakeholders.css'
import {Demo} from "../components";
import "./../App.css";
const Demo_page = () => {
  return (
    <div>
<div className="page">
<Demo />
</div>
     
      
    </div>
  );
};

export default Demo_page;
